import React, { Component } from 'react';
import FieldWrapper from '../Form/FieldWrapper';
import Input from '../Form/Input';
import Button from '../Button/Button';

export default class CustomerForm extends Component {
    state = {
        formData: {
            idUser: this.props.data && this.props.data.hasOwnProperty('idUser') ? this.props.data.idUser : null,
            username: this.props.data && this.props.data.hasOwnProperty('username') ? this.props.data.username : '',
            email: this.props.data && this.props.data.hasOwnProperty('email') ? this.props.data.email : '',
            phone: this.props.data && this.props.data.hasOwnProperty('phone') ? this.props.data.phone : '',
        },
        valid: true
    };

    static defaultProps = {
        onSubmit: () => {},
        onCancel: () => {},
    };

    componentDidMount() {
        this.validate(this.form);
    }

    handleChange = field => {
        const formData = Object.assign(this.state.formData, {[field.name]: field.value});
        this.setState({formData});
        this.validate(this.form);
    };

    handleCancel = event => {
        event.preventDefault();
        this.props.onCancel();
    };

    handleSubmit = event => {
        event.preventDefault();
        this.validate(this.form);
        this.props.onSubmit(this.state.formData);
    };

    validate(form) {
        this.setState({
            valid: form.checkValidity()
        });
    }

    render() {
        return (
            <form ref={ref => this.form = ref}
                  noValidate
                  onSubmit={this.handleSubmit}>
                <section className="modal-card-body" style={{position: 'relative'}}>
                    <div className="columns is-multiline">
                        <div className="column is-half">
                            <FieldWrapper label="Usuario"
                                          valid={this.username && this.username.input.validity.valid}
                                          validationMessage={this.username && this.username.input.validationMessage}>
                                <Input ref={ref => this.username = ref}
                                       placeholder="Usuario"
                                       name="username"
                                       value={this.state.formData.username}
                                       required
                                       readonly={this.state.formData.idUser}
                                       disabled={this.state.formData.idUser}
                                       onChange={this.handleChange}
                                />
                            </FieldWrapper>
                        </div>
                        <div className="column is-half">
                            <FieldWrapper label="E-mail"
                                          valid={this.email && this.email.input.validity.valid}
                                          validationMessage={this.email && this.email.input.validationMessage}>
                                <Input ref={ref => this.email = ref}
                                       placeholder="E-mail"
                                       name="email"
                                       type="email"
                                       value={this.state.formData.email}
                                       required
                                       readonly={this.state.formData.idUser}
                                       disabled={this.state.formData.idUser}
                                       onChange={this.handleChange}
                                />
                            </FieldWrapper>
                        </div>
                        <div className="column is-half">
                            <FieldWrapper label="Teléfono">
                                <Input placeholder="Teléfono"
                                       name="phone"
                                       value={this.state.formData.phone}
                                       onChange={this.handleChange}
                                />
                            </FieldWrapper>
                        </div>
                    </div>
                </section>
                <footer className="modal-card-foot">
                    <Button icon={`${this.props.sending ? 'sync-alt' : ''}`}
                            spin={this.props.sending}
                            disabled={this.props.sending || !this.state.valid}
                            extraClasses="is-success"
                            type="submit"
                            text={`${this.props.sending ? 'Por favor, espera…' : 'OK'}`}
                    />
                    <Button text="Cancelar"
                            onClick={this.handleCancel} />
                </footer>
            </form>
        );
    }
}